@if (isInstalmentPlan) {
  <section class="center-layout">
    <div class="form-central__content">
      <div class="form-central__form">
        <h6 class="heading__6">
          You're About to Sign Up for Recurring Payment for <br />
          <div class="heading__6 mt-2 text-primary">
            {{ recurringPayment?.name | titlecase }}
          </div>
        </h6>
        <div class="row mt-5">
          <div class="row-col__md-6 border-right-gray pr-3">
            <div class="subscription">
              <div class="subscription-details">
                <div class="subscription-details-title">
                  {{ isInstalmentPlan ? "Instalment" : "Subscription" }} Plan
                  Name
                </div>
                <div class="subscription-details-value">
                  {{ recurringPayment?.name | titlecase }}
                </div>
              </div>
              <div class="subscription-details">
                <div class="subscription-details-title">Description</div>
                <div class="subscription-details-value">
                  {{ recurringPayment?.description }}
                </div>
              </div>
              <div class="subscription-details">
                <div class="subscription-details-title">Billing cycle</div>
                <div class="subscription-details-value">
                  {{ recurringPayment?.billingCycle }}
                </div>
              </div>
            </div>
          </div>
          <div class="row-col__md-6 pl-3">
            <div class="subscription">
              <div class="subscription-details">
                <div class="subscription-details-title">Number of payments</div>
                <div class="subscription-details-value">
                  {{
                    recurringPayment?.planDuration ??
                      recurringPayment?.maxNumberOfPayments
                  }}
                </div>
              </div>
              <div class="subscription-details">
                <div class="subscription-details-title">
                  {{ isInstalmentPlan ? "Total instalment" : "Subscription" }}
                  Amount
                </div>
                <div
                  class="subscription-details-value subscription-details-value__amount"
                >
                  {{ recurringPayment?.currency }}
                  {{ recurringPayment?.amount }}
                </div>
              </div>
              <div class="subscription-details">
                <div class="subscription-details-title">
                  <small
                    ><i
                      >Note: Total payment is above. The first installment will
                      be deducted first, then each cycle's deductions.</i
                    ></small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="centered-section">
          <div class="checkbox-container mt-5">
            <input type="checkbox" class="mr-2" [(ngModel)]="agreeTerms" />
            <span class="terms-text">
              I agree to the
              <a
                class="text_primary link"
                href="https://www.myrexpay.ng/terms"
                target="_blank"
              >
                Terms
              </a>
              and
              <a
                href="https://www.myrexpay.ng/policy"
                target="_blank"
                class="text_primary link"
              >
                Conditions
              </a>
              of Rexpay
            </span>
          </div>

          <button
            class="btn btn__primary w-50 no-margin-l"
            (click)="handleAccept()"
            [disabled]="!agreeTerms"
          >
            Accept
          </button>
        </section>
      </div>
    </div>
  </section>
} @else {
  <section class="center-layout">
    <div class="form-central__content">
      <div class="form-central__form">
        <h6 class="heading__6">
          You're About to Sign Up for Recurring Payment for <br />
          <div class="heading__6 mt-2 text-primary">
            {{ recurringPayment?.name | titlecase }}
          </div>
        </h6>
        <div class="row mt-5">
          <div class="row-col__md-6 border-right-gray pr-3">
            <div class="subscription">
              <div class="subscription-details">
                <div class="subscription-details-title">
                  {{ isInstalmentPlan ? "Instalment" : "Subscription" }} Plan
                  Name
                </div>
                <div class="subscription-details-value">
                  {{ recurringPayment?.name | titlecase }}
                </div>
              </div>
              <div class="subscription-details">
                <div class="subscription-details-title">Description</div>
                <div class="subscription-details-value">
                  {{ recurringPayment?.description }}
                </div>
              </div>
              <div class="subscription-details">
                <div class="subscription-details-title">Number of payments</div>
                <div class="subscription-details-value">
                  {{
                    recurringPayment?.planDuration ??
                      recurringPayment?.maxNumberOfPayments
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="row-col__md-6 pl-3">
            <div class="subscription">
              <div class="subscription-details">
                <div class="subscription-details-title">Billing cycle</div>
                <div class="subscription-details-value">
                  {{ recurringPayment?.billingCycle }}
                </div>
              </div>
              <div class="subscription-details">
                <div class="subscription-details-title">
                  {{ isInstalmentPlan ? "Total instalment" : "Subscription" }}
                  Amount
                </div>
                <div
                  class="subscription-details-value subscription-details-value__amount"
                >
                  {{ recurringPayment?.currency }}
                  {{ recurringPayment?.amount }}
                </div>
              </div>
            </div>

            <div class="checkbox-container mt-5">
              <input type="checkbox" class="mr-2" [(ngModel)]="agreeTerms" />
              <span class="terms-text">
                I agree to the
                <a
                  class="text_primary link"
                  href="https://www.myrexpay.ng/terms"
                  target="_blank"
                  >Terms
                </a>
                and
                <a
                  href="https://www.myrexpay.ng/policy"
                  target="_blank"
                  class="text_primary link"
                  >Conditions
                </a>
                of Rexpay
              </span>
            </div>

            <div class="btn-groups flexed mt-2">
              <button
                class="btn btn__primary w-50 no-margin-l"
                (click)="handleAccept()"
                [disabled]="!agreeTerms"
              >
                Accept
              </button>
              <!-- <button
								class="btn btn__secondary w-50 no-margin-l"
								(click)="handleDecline()"
							>
								Decline
							</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}

@if (showModal) {
  <app-modal
    [modalType]="'primary'"
    [header]="'Decline Recurring payments'"
    [subHeader]="subHeader"
    [buttonText]="'Decline Payment'"
    (cancel)="showModal = false"
    (submit)="decline()"
  >
  </app-modal>
}
